import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AxCommonsApiModule } from 'src/app/ax-commons-api/ax-commons-api.module';
import { AxComponentsModule } from 'src/app/components/ax-components.module';
import { NewsDetailPageRoutingModule } from 'src/app/pages/global/news-detail/news-detail-routing.module';
import { NewsDetailPage } from 'src/app/pages/global/news-detail/news-detail.page';
import { GalleryComponent } from 'ng-gallery';
import { PrependServerToFileSrcPipe } from 'src/app/pipes/prepend-server-to-file-src.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NewsDetailPageRoutingModule,
    AxCommonsApiModule,
    AxComponentsModule,
    GalleryComponent,
  ],
  declarations: [NewsDetailPage],
  providers: [
    PrependServerToFileSrcPipe,
  ],
})
export class NewsDetailPageModule {
}
